import { createAction } from 'redux-actions';

export const formStartNew = createAction('FORM_STARTNEW');
export const formBuilderLoad = createAction('FORMBUILDER_LOAD');
export const formBuilderLoaded = createAction('FORMBUILDER_LOADED');
export const formBuilderUnload = createAction('FORMBUILDER_UNLOAD');
export const formUpdateSections = createAction('FORM_UPDATE_SECTIONS');
export const formRenameMultipleField = createAction('FORM_RENAME_MULTIPLE_FIELD');
export const formUpdated = createAction('FORM_UPDATED');
export const formUpdateFieldIndex = createAction('FORM_UPDATE_FIELD_INDEX');
export const formUpdateEntries = createAction('FORM_UPDATE_ENTRIES');
export const formUpdateMultipleEntries = createAction('FORM_UPDATE_MULTIPLE_ENTRIES');
export const formChangeSection = createAction('FORM_CHANGE_SECTION');
export const formReorderSections = createAction('FORM_REORDER_SECTIONS');
export const formUpdateName = createAction('FORM_UPDATE_NAME');
export const formSetEntries = createAction('SET_FORM_ENTRIES');
export const formValidate = createAction('FORM_VALIDATE');
export const formUpdateSectionStatus = createAction('FORM_UPDATE_SECTION_STATUS');
export const formSave = createAction('FORM_SAVE');
export const formDelete = createAction('FORM_DELETE');
export const formDeleted = createAction('FORM_DELETED');
export const formSaved = createAction('FORM_SAVED');
export const formSaveAndRedirect = createAction('FORM_SAVE_AND_REDIRECT');
export const formDiscardChanges = createAction('FORM_DISCARD_CHANGES');
export const formUpdateVisibilityAndValidation = createAction('FORM_UPDATE_VISIBILITY_AND_VALIDATION');
